/**
 * 특정 기부(donation) 상품의 "실시간 모금" 표기를 DB(sales_count)/Redis 값 대신
 * 지정 텍스트로 고정한다. 캠페인 종료 후 실제 정산액을 수동으로 표기하기 위함.
 *
 *   key   = shop.productKey
 *   value = i18n 템플릿(realTimeDonationRaised)의 {n} 자리에 그대로 치환될 문자열.
 *           템플릿이 이미 "$"를 포함하므로("실시간 ${n} 모금") 값에는 "$"를 넣지 않는다.
 *           예) "8,888 + 888" → "실시간 $8,888 + 888 모금"
 *
 * 목록(shop-item.tsx)과 상세(shop-detail-info-box.tsx) 두 곳에서 공유한다.
 */
export const DONATION_AMOUNT_TEXT_OVERRIDES: Record<string, string> = {
  // HERITAGE IN PEACE | UNESCO World Heritage Fund (JUSPEACE x GIFTIFAN x GD FANUNION)
  '7d9b0d50-e19a-4526-ace9-1a761e60b2e6': '8,888 + 888',
};
